export default {
  title: 'Vytvoriť {level}',
  helperText: 'Tento dialóg umožňuje vytváranie nových zariadení (pokiaľ to licencia dovoľuje).',
};
